import { Route, Routes } from 'react-router-dom';
import HomePage from './pages/home';
import DigiLayout from './layout/DigiLayout';
import RegistrationPage from './pages/registrationPage';
import PageNotFound from './pages/pageNotFound';

function App() {

  return (
    <>

      <Routes>
        {/* <Route path='/' element={<Home />} /> */}
        <Route path='/'>
          <Route index element={<DigiLayout><HomePage /></DigiLayout>} />
          <Route path="register" element={<DigiLayout><RegistrationPage /></DigiLayout>} />
        </Route>
        <Route path="*" element={<PageNotFound />} />



      </Routes>
    </>
  )
}

export default App;
